import React, { createContext, useState } from "react";

let user;
class DatabaseProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuth: false,
      token: "",
      user: null,
      decoded: null,
      contact: null,
      LineTypes: null,
      readOnlyMode: false,
      showLoading: false,
      loadingFouser: null,
    };
    const [LineTypes, setLineTypes] = useState();
    this.setState({ contact: "Contacto" });

    //Change for server api address
    let varName = "LineTypes";
    user[varName] = "LineTypes Object";
    varName = "Msg";
    user[varName] = "Mensaje";
    return user;
  }
}

export const UserContext = createContext(user);
